// components/PopupForm/PopupForm.jsx
import React from "react";
import "./PopupForm.scss"; // Reuse your existing styles

const PopupForm = ({ title, form, onChange, onSubmit, onClose, fields }) => {
  return (
    <div className="popup">
      <div className="popup-inner">
        <h2>{title}</h2>
        <form onSubmit={onSubmit}>
          {fields.map(({ label, name, type }) => (
            <div className="form-group" key={name}>
              <label>{label}</label>
              {type === "textarea" ? (
                <textarea value={form[name]} onChange={(e) => onChange(name, e.target.value)} />
              ) : (
                <input type={type} value={form[name]} onChange={(e) => onChange(name, e.target.value)} />
              )}
            </div>
          ))}
          <div className="buttons">
            <button type="submit">Submit</button>
            <button type="button" className="remove" onClick={onClose}>
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PopupForm;
